import axios from 'axios';
import PlanEditar from '../types/PlanEditar';
import { FechaHoraPostgreSQLTZ } from './FechaHoraPostgreSQLTZ';

async function GuardarPlan(elPlan: PlanEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_plan"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "plan": [
                {
                    "id": elPlan.id,
                    "title": elPlan.title,
                    "description": elPlan.description,
                    "maxconyuge": elPlan.maxconyuge,
                    "maxmenores": elPlan.maxmenores,
                    "maxmayores": elPlan.maxmayores,
                    "headercolor": elPlan.headercolor,
                    "headercolorhover": elPlan.headercolorhover,
                    "price": elPlan.price,
                    "pricedebito": elPlan.pricedebito,
                    "priceanual": elPlan.priceanual,
                    "codigoplan": elPlan.codigoplan,
                    "habilitado": elPlan.habilitado,
                    "maxedadtitular": elPlan.maxedadtitular,
                    "maxedadconyuge": elPlan.maxedadconyuge,
                    "maxedadmenor": elPlan.maxedadmenor,
                    "maxedadmayor": elPlan.maxedadmayor,
                    "mostrar": elPlan.mostrar,
                    "sol_celu": elPlan.sol_celu,
                    "val_celu": elPlan.val_celu,
                    "sol_email": elPlan.sol_email,
                    "val_email": elPlan.val_email,
                    "pago_online": elPlan.pago_online,
                    "dado_de_baja": elPlan.dado_de_baja,
                    "fecha_baja": elPlan.dado_de_baja === 'S' ? elPlan.fecha_baja : null,
                    "fecha_modificacion": elPlan.fecha_modificacion,
                    "pricemenor": elPlan.pricemenor,
                    "pricedebitomenor": elPlan.pricedebitomenor,
                    "priceanualmenor": elPlan.priceanualmenor,
                    "pricemayor": elPlan.pricemayor,
                    "pricedebitomayor": elPlan.pricedebitomayor,
                    "priceanualmayor": elPlan.priceanualmayor
                }
            ]
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarPlan;